import React from 'react';
import styled from '@emotion/styled';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import PropTypes from 'prop-types';


const Mensaje = styled.p`
    background-color: rgb(127, 224, 237);
    margin-top: 2rem;
    padding: 1rem;
    text-align: center;
`;

const ResultadoCotizacion = styled.div`
    text-align: center;
    padding: .5rem;
    border: 1px solid #26c6da;
    background-color: rgb(127, 224, 237);
    margin-top: 1rem;
    position: relative;
`;

const TextoCotizacion = styled.p`
color: #00838f;
padding: 1rem;
text-transform: uppercase;
font-weight: bold;
margin: 0;
`;

export const Resultado = ({cotizacion}) => {

    return (
        (cotizacion === 0) 
        ? <Mensaje>Elige marca, año y tipo de seguro</Mensaje> 
        : ( 
            <ResultadoCotizacion>
        <TransitionGroup
        component="p"
        ClassName="resultado"
        >
            <CSSTransition
            ClassName="resultado"
            key={cotizacion}
            timeout={{enter: 100, exit: 100}}
            >
            <TextoCotizacion>El total es: ${cotizacion}</TextoCotizacion> 
            </CSSTransition>
        </TransitionGroup>
        </ResultadoCotizacion>
        )
    )
}

Resultado.propTypes = {
    cotizacion: PropTypes.number.isRequired
}